"use strict";

import angular from "angular";

import template from "./table-management-assets.component.html";
import "./themes/table-management-assets.component-dark.scss";
import "./themes/table-management-assets.component.scss";

import _ from "lodash";
import * as DateUtils from "../../../utils/date/date";

class TableManagementAssetsComponent {
    constructor() {
        this.tables = [];
        this.viewTables = [];
        this.seriesChart = [];
        this.pointsChart = [];
        this.visualization = {};
        this.labelsComparation = {
            period: "",
            comparation: ""
        };
    }

    $onInit() {
        this.infoCalculateList = [
            { name: "Imobilizado", value: "40%" },
            { name: "Imobilizado Liquido", value: "40%" },
            { name: "Estoque", value: "30%" }
        ];
        this._setLabelsComparation();
        this._mountTables();
        this._setVisualization();
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "currentComparation.previousValue"))) {
            this._setLabelsComparation();
            this._mountTables();
            this._setVisualization();
        }
    }

    _getLabelComparation(periodInfo) {
        const comparationMonth = this.currentComparation.date.getUTCMonth();
        const comparationYear = this.currentComparation.date.getUTCFullYear();

        const periodMonth = this.currentPeriod.date.getUTCMonth();
        const periodYear = this.currentPeriod.date.getUTCFullYear();

        return {
            period: `${periodInfo[periodMonth]} ${periodYear}`,
            comparation: `${periodInfo[comparationMonth]} ${comparationYear}`
        };
    }

    _setLabelsComparation() {
        const periods = {
            monthly: () => {
                this.labelsComparation = {
                    period: DateUtils.dateToString(
                        this.currentPeriod.date,
                        "MMM, yyyy"
                    ),
                    comparation: DateUtils.dateToString(
                        this.currentComparation.date,
                        "MMM, yyyy"
                    )
                };
            },
            quarterly: () => {
                const periodInfo = {
                    2: "1° T",
                    5: "2° T",
                    8: "3° T",
                    11: "4° T"
                };

                const { period, comparation } = this._getLabelComparation(
                    periodInfo
                );

                this.labelsComparation = {
                    period,
                    comparation
                };
            },
            semester: () => {
                const periodInfo = {
                    5: "1° S",
                    11: "2° S"
                };

                const { period, comparation } = this._getLabelComparation(
                    periodInfo
                );

                this.labelsComparation = {
                    period,
                    comparation
                };
            },
            yearly: () => {
                const periodInfo = {
                    11: ""
                };

                const { period, comparation } = this._getLabelComparation(
                    periodInfo
                );

                this.labelsComparation = {
                    period,
                    comparation
                };
            }
        };

        if (this.currentPeriod.period) periods[this.currentPeriod.period]();
    }

    _setVisualization() {
        if (!_.get(this.series, "length")) return;
        const structure = { chart: this.configs.chart };
        const mainSerieId = _.get(this.configs.chart, "series[0]._id");
        const seriesData = this.series.filter((s) => s._id === mainSerieId);
        const pointsData = this.points.filter((p) => p.s === mainSerieId);
        if (this.goals && this.visualizationData?.goals?.length) {
            const mainGoals = this.visualizationData?.goals.find(
                (s) => s.s == mainSerieId
            );
            structure.chart.goals = [
                {
                    type: "line",
                    _id: mainGoals.r,
                    color: "cyan.dark"
                }
            ];
            const serie = this.series.find(
                (s) => s.referenceId === mainGoals.r
            );
            seriesData.push(serie);
            pointsData.push(...this.points.filter((p) => p.s === serie._id));
        }
        this.visualization = structure;
        this.seriesChart = seriesData;
        this.pointsChart = pointsData;
    }

    _getLast = (_id) => {
        const point = _.findLast(this.points, { s: _id });

        return _.get(point, "m.v");
    };

    _getComparation(_id) {
        const point = _.findLast(this.points, (p) => {
            return p.s === _id && +this.currentComparation.date === +p.t;
        });

        return _.get(point, "m.v");
    }

    _mountTables() {
        if (!_.get(this.series, "length")) return;
        this.tables = this.configs.table;

        this.tables.forEach((table, index) => {
            this.viewTables[index] = {
                thead: table.thead,
                total: this._getLast(table.total),
                totalComparation: this._getComparation(table.total),
                rows: table.rows.map((row) => {
                    const serie = this.series.find((s) => s._id === row);

                    return {
                        name: _.get(serie, "name") || "",
                        v: this._getLast(row) || 0,
                        c: this._getComparation(row) || 0
                    };
                })
            };
        });
    }
}

TableManagementAssetsComponent.$inject = [];

const name = "tableManagementAssetsComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: TableManagementAssetsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
